/// <reference types="@types/ckeditor" />
import { Component, OnInit, AfterViewInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Routes, RouterModule, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment'

import { ConfigurableLinkListComponent } from '../../common/component/configurable_link_list/configurable_link_list.component';
import { RaService, NotificationService, emailTemplate } from '../../core';
import { notification_template } from '../../core/models/notification_template-model';
import { AlertComponent, EnumAlertType } from '../../common/component/alert/alert.component';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditorComponent implements OnInit {
  @ViewChild(AlertComponent, { static: true }) alertController: AlertComponent;

  templateList: [
    {
      textContent:string,
      [key:string]:any
    }
  ] = [{key:[],textContent:''}];
  selectedTemplate: notification_template = {
    NotificationTemplateID: "",
    Name: "",
    ReplyTo: "",
    CC: "",
    BCC: "",
    Subject: "",
    FailedAuditTemplate: "",
    PassedAuditTemplate: "",
    AuditType: 0,
    SASendLoaded: false,
    SASendDiscrepancy: false,
    SASendNotLoaded: false,
    SAPassLoaded: false,
    SAFailLoaded: false,
    SAPassNotLoaded: false,
    SAFailNotLoaded: false,
    SAPassDiscrepancy: false,
    SAFailDiscrepancy: false,
    RAPassAvailable: false,
    RAPassAvailableHigher: false,
    RAPassAvailableLower: false,
    RAPassRNA: false,
    RAPassHNA: false,
    RAFailAvailable: false,
    RAFailAvailableHigher: false,
    RAFailAvailableLower: false,
    RAFailRNA: false,
    RAFailHNA: false,
    RASendAvailable: false,
    RASendAvailableHigher: false,
    RASendAvailableLower: false,
    RASendRNA: false,
    RASendHNA: false,
    isDefault: false
  };
  NotificationTemplateID: string;

  showGridLines: boolean = true;
  showGDSInfo: boolean = true;
  showGDSName: boolean = true;
  showChainCode: boolean = true;
  showPropCode: boolean = true;
  showRateAccessCode: boolean = true;
  showRateInfo: boolean = true;
  showCurrencyCode: boolean = true;
  showExpectedRate: boolean = true;
  showProvidedRate: boolean = true;
  showHotelInfo: boolean = true;
  showHotelName: boolean = true;
  showHotelAddress: boolean = true;
  showHotelCity: boolean = true;
  showHotelState: boolean = true;
  showHotelCountry: boolean = true;
  showAmenitiesPolicyInfo: boolean = true;
  showBreakfast: boolean = true;
  showInternet: boolean = true;
  showParking: boolean = true;
  showAirportTransport: boolean = true;
  showLocalTransport: boolean = true;
  showBidCancelPolicy: boolean = true;
  showWithCommission: boolean = true;
  showPercentCommission: boolean = true;

  headerTextForegroundColor: string = "#000000";
  headerTextBackgroundColor: string = "#ffffff";
  gridTextForegroundColor: string = "#000000";
  gridTextBackgroundColor: string = "#ffffff";
  currentPath: string;
  auditType;
  gridStatus1: string;
  gridStatus2: string;

  beginTemplate: string = emailTemplate.beginTemplate;
  endTemplate: string = emailTemplate.endTemplate;

  isNewTemplate: boolean = false;
  disabled: boolean = false;
  RACClass: string = "indentLeft";
  RACDisabled: string = "showGDSInfo";
  auditPassedTile: string = "Audit Passed Template"
  ckEditorUrl:string = environment.baseWebApiUrl + "Scripts/ckeditor/ckeditor.js";//environment.baseWebApiUrl+"Scripts/ckeditor/ckeditor.js"

  constructor(
    private route: ActivatedRoute,
    private service: RaService,
    private notificationservice: NotificationService) { }

  // radio button click functions//
  onPassLoadedChecked(event) {
    this.selectedTemplate.SAPassLoaded = true; this.selectedTemplate.SAFailLoaded = false;
  }
  onFailLoadedChecked(event) {
    this.selectedTemplate.SAFailLoaded = true; this.selectedTemplate.SAPassLoaded = false;
  }
  onPassNotLoadedChecked(event) {
    this.selectedTemplate.SAPassNotLoaded = true; this.selectedTemplate.SAFailNotLoaded = false;
  }
  onFailNotLoadedChecked(event) {
    this.selectedTemplate.SAFailNotLoaded = true; this.selectedTemplate.SAPassNotLoaded = false;
  }
  onPassDiscrepancyChecked(event) {
    this.selectedTemplate.SAPassDiscrepancy = true; this.selectedTemplate.SAFailDiscrepancy = false;
  }
  onFailDiscrepancyChecked(event) {
    this.selectedTemplate.SAFailDiscrepancy = true; this.selectedTemplate.SAPassDiscrepancy = false;
  }

  onPassAvailableChecked(event) {
    this.selectedTemplate.RAPassAvailable = true; this.selectedTemplate.RAFailAvailable = false;
  }
  onFailAvailableChecked(event) {
    this.selectedTemplate.RAFailAvailable = true; this.selectedTemplate.RAPassAvailable = false;
  }
  onPassAvailableHigherChecked(event) {
    this.selectedTemplate.RAPassAvailableHigher = true; this.selectedTemplate.RAFailAvailableHigher = false;
  }
  onFailAvailableHigherChecked(event) {
    this.selectedTemplate.RAFailAvailableHigher = true; this.selectedTemplate.RAPassAvailableHigher = false;
  }
  onPassAvailableLowerChecked(event) {
    this.selectedTemplate.RAPassAvailableLower = true; this.selectedTemplate.RAFailAvailableLower = false;
  }
  onFailAvailableLowerChecked(event) {
    this.selectedTemplate.RAFailAvailableLower = true; this.selectedTemplate.RAPassAvailableLower = false;
  }
  onPassRateNotAvailableChecked(event) {
    this.selectedTemplate.RAPassRNA = true; this.selectedTemplate.RAFailRNA = false;
  }
  onFailRateNotAvailableChecked(event) {
    this.selectedTemplate.RAFailRNA = true; this.selectedTemplate.RAPassRNA = false;
  }
  onPassHotelNotAvailableChecked(event) {
    this.selectedTemplate.RAPassHNA = true; this.selectedTemplate.RAFailHNA = false;
  }
  onFailHotelNotAvailableChecked(event) {
    this.selectedTemplate.RAFailHNA = true; this.selectedTemplate.RAPassHNA = false;
  }


  ngOnInit() {
    //to do switch to rate audit, rate avail
    let crrnt = this.route.snapshot.url;
    this.currentPath = crrnt[1].path;
    this.RACClass = "indentLeft";
    if (this.currentPath == "rate-audit") {
      this.auditPassedTile = "Audit Passed Template"
      this.disabled = false;
      this.auditType = 1;
      this.gridStatus1 = "Loaded";
      this.gridStatus2 = "Discrepancy";
      this.RACClass = "indentLeft";
    } else if (this.currentPath == "rate-availability") {
      this.auditPassedTile = "Audit Passed Template"
      this.disabled = false;
      this.auditType = 3;
      this.gridStatus1 = "Available";
      this.gridStatus2 = "Available";
      this.RACClass = "indentLeft";
    } else if (this.currentPath == "reverse-audit") {
      this.auditType = 2;
      this.disabled = true;
      this.RACClass = "";
      this.RACDisabled = "false";
      this.auditPassedTile = "Found Loaded for Reverse Audit";
    }

    for (let ctr = 0; ctr < this.templateList.length; ctr++) {
      let template = this.templateList[ctr];
      template.AuditType = this.auditType;
    }

    this.LoadPageDetails();
  }

  changeSelectedListDetails(event) {
    this.selectedTemplate = event.item;
    this.loadTemplateDetails(event.item);
    this.isNewTemplate = false;
  }
  public tab1Class: string = "k-item k-state-default k-state-active";

  onSaveTemplate() {
    if(this.templateList.length <= 0 ){
      this.isNewTemplate = true;
      this.selectedTemplate.AuditType = this.auditType;
      this.selectedTemplate.SAPassLoaded = true;
      this.selectedTemplate.SAPassNotLoaded = false;
      this.selectedTemplate.SAPassDiscrepancy = false;
      this.selectedTemplate.SAFailLoaded = false;
      this.selectedTemplate.SAFailNotLoaded = true;
      this.selectedTemplate.SAFailDiscrepancy = true;
      this.selectedTemplate.SASendLoaded = false;
      this.selectedTemplate.SASendNotLoaded = true;
      this.selectedTemplate.SASendDiscrepancy = true;
      this.selectedTemplate.RAPassAvailable = true;
      this.selectedTemplate.RAFailAvailable = false;
      this.selectedTemplate.RAPassAvailableHigher = false;
      this.selectedTemplate.RAFailAvailableHigher = true;
      this.selectedTemplate.RAPassAvailableLower = true;
      this.selectedTemplate.RAFailAvailableLower = false;
      this.selectedTemplate.RAPassRNA = false;
      this.selectedTemplate.RAFailRNA = true;
      this.selectedTemplate.RAPassHNA = false;
      this.selectedTemplate.RAFailHNA = true;
      this.selectedTemplate.RASendAvailable = false;
      this.selectedTemplate.RASendAvailableHigher = true;
      this.selectedTemplate.RASendAvailableLower = false;
      this.selectedTemplate.RASendRNA = true;
      this.selectedTemplate.RASendHNA = true;
      this.selectedTemplate.PassedAuditTemplate = "";
      this.selectedTemplate.FailedAuditTemplate = "";
      this.selectedTemplate.isDefault = false;

    }
    if (this.selectedTemplate.ReplyTo == "") {
      this.alertController.showAlertMessage(5000, "The ReplyTo field is required.", EnumAlertType.Error);
    } else if (this.selectedTemplate.Subject == "") {
      this.alertController.showAlertMessage(5000, "The Subject field is required. ", EnumAlertType.Error);
    } else if (this.selectedTemplate.Name == "") {
      this.alertController.showAlertMessage(5000, "The Name field is required. ", EnumAlertType.Error);
    } else if (!this.ValidateEmail(this.selectedTemplate.ReplyTo)) {
      this.alertController.showAlertMessage(5000, "Please enter a valid From E-mail address ", EnumAlertType.Error);
    } else if (this.selectedTemplate.CC != "" && !this.ValidateEmail(this.selectedTemplate.CC)) {
      this.alertController.showAlertMessage(5000, "Please enter a valid From CC address ", EnumAlertType.Error);
    } else if (this.selectedTemplate.BCC != "" && !this.ValidateEmail(this.selectedTemplate.BCC)) {
      this.alertController.showAlertMessage(5000, "Please enter a valid From BCC address ", EnumAlertType.Error);
    } else {
      if (this.selectedTemplate.FailedAuditTemplate.indexOf(this.beginTemplate) == -1) {
        this.selectedTemplate.FailedAuditTemplate = this.beginTemplate + this.selectedTemplate.FailedAuditTemplate + this.endTemplate;
      }
      if (this.selectedTemplate.PassedAuditTemplate.indexOf(this.beginTemplate) == -1) {
        this.selectedTemplate.PassedAuditTemplate = this.beginTemplate + this.selectedTemplate.PassedAuditTemplate + this.endTemplate;
      }
      if (!this.isNewTemplate) {
        this.isBusy = true;
        this.notificationservice.SaveNotificationTemplate(this.selectedTemplate)
          .subscribe(data => {
            this.alertController.showAlertMessage(5000, "Template saved successfully ", EnumAlertType.Success);
            this.templateList.sort(this.compare);
            this.reloadtemplate(this.selectedTemplate);
          }, (err) => console.log(err),()=>{this.isBusy=false});
      } else {
        this.isNewTemplate = false;
        this.isBusy = true;
        this.notificationservice.AddNewNotificationTemplate(this.selectedTemplate)
          .subscribe(data => {
            this.isNewTemplate = false;
            this.templateList.push({key:this.selectedTemplate,textContent:''});
            this.templateList.sort(this.compare);
            this.reloadtemplate(this.selectedTemplate);
            this.selectedTemplate.NotificationTemplateID = data.json();
            this.alertController.showAlertMessage(5000, "Template added successfully ", EnumAlertType.Success);
          }, (err) => console.log(err),()=>{this.isBusy=false});
      }
    }
  }

  compare(a, b) {
    if(a.Name && b.Name){
      return a.Name.toLowerCase().localeCompare(b.Name.toLowerCase());
    }
    return a.Name == b.Name?0:(a.Name?-1:1);
  }

  reloadtemplate(obj) {
    this.templateList.forEach(element => {
      element.textContent = element.Name;
      this.loadTemplateDetails(obj);
    })
  }


  onNewTemplate() {
    this.isNewTemplate = true;

    this.selectedTemplate = {
      NotificationTemplateID: "",
      Name: "Standard Audit Template",
      ReplyTo: "",
      CC: "",
      BCC: "",
      Subject: "",
      AuditType: this.auditType,
      SAPassLoaded: true,
      SAPassNotLoaded: false,
      SAPassDiscrepancy: false,
      SAFailLoaded: false,
      SAFailNotLoaded: true,
      SAFailDiscrepancy: true,
      SASendLoaded: false,
      SASendNotLoaded: false,
      SASendDiscrepancy: false,

      RAPassAvailable: true,
      RAFailAvailable: false,
      RAPassAvailableHigher: false,
      RAFailAvailableHigher: true,
      RAPassAvailableLower: true,
      RAFailAvailableLower: false,
      RAPassRNA: false,
      RAFailRNA: true,
      RAPassHNA: false,
      RAFailHNA: true,
      RASendAvailable: false,
      RASendAvailableHigher: false,
      RASendAvailableLower: false,
      RASendRNA: false,
      RASendHNA: false,

      PassedAuditTemplate: "",
      FailedAuditTemplate: "",
      isDefault: false,

    };
    //update the html of the list so no template appears as selected
    let divArray = document.getElementsByClassName('configurable_link_list_element');
    for (let ctr = 0; ctr < divArray.length; ctr++) {
      let div = divArray[ctr];
      div.className = 'configurable_link_list_element';
    }
  }

  loadTemplateDetails(item) {
    this.isNewTemplate = false;

  }

  onSetDefaultNotificationTemplate() {
    if (!this.isNewTemplate) {
      this.isBusy = true;
      this.notificationservice.SetDefaultNotificationTemplate(this.selectedTemplate.NotificationTemplateID, this.auditType).subscribe(data => {
        for (let ctr = 0; ctr < this.templateList.length; ctr++) {
          let template = this.templateList[ctr];
          template.isDefault = false;
        }
        this.selectedTemplate.isDefault = true;
        this.alertController.showAlertMessage(5000, "Template set to default template ", EnumAlertType.Success);
      },()=>{},()=>{this.isBusy=false});
    } else {
      this.alertController.showAlertMessage(5000, "Please save the template before making it default template ", EnumAlertType.Error);
    }
  }

  ValidateEmail(mail) {
    let Regexp = new RegExp('(([a-zA-Z\-0-9\.]+@)([a-zA-Z\-0-9]+\\.)([a-zA-Z]+)[;]*)+');
    if (Regexp.test(mail)) {
      return true;
    }
    return false;
  }
public isBusy:boolean=false;
  LoadPageDetails() {
    this.isBusy = true;
    this.isNewTemplate = false;
    this.notificationservice.GetNotificationTemplate(this.auditType).subscribe(data => {
      this.templateList = data;
      if (data) {
        data.forEach(element => {
          element.textContent = element.Name;
          if (element.isDefault) {
            this.selectedTemplate = element;
          }
        });
      } else {
        console.log('There are no templates to load');
      }
    },()=>{},()=>{this.isBusy=false});
  }
  ClickHotelField(hotelFieldTag) {
    var ckeditor = (<any>window).CKEDITOR;
    var editor;
    //there should only be one editor
    //so grab the first propert after some basic checking
    //and break out of the for loop
    for (let prop in ckeditor.instances) {
      if (prop.match(/^editor/)) {
        editor = ckeditor.instances[prop];
      }
    }
    if (editor) {
      editor.insertHtml('{{' + hotelFieldTag + '}}');
    }
  }

  ModelChangeShowGDSInfo() {
    this.showGDSName = this.showGDSInfo;
    this.showChainCode = this.showGDSInfo;
    this.showPropCode = this.showGDSInfo;
    if (this.currentPath != "reverse-audit") {
      this.showRateAccessCode = this.showGDSInfo;
    }
  }


  ModelChangeShowHotelInfo() {
    this.showHotelName = this.showHotelInfo;
    this.showHotelAddress = this.showHotelInfo;
    this.showHotelCity = this.showHotelInfo;
    this.showHotelState = this.showHotelInfo;
    this.showHotelCountry = this.showHotelInfo;
  }

  ModelChangeShowRateInfo() {
    this.showCurrencyCode = this.showRateInfo;
    this.showExpectedRate = this.showRateInfo;
    this.showProvidedRate = this.showRateInfo;
    this.showWithCommission = this.showRateInfo;
    this.showPercentCommission = this.showRateInfo;
  }

  ModelChangeshowAmenitiesPolicyInfo() {
    this.showBreakfast = this.showAmenitiesPolicyInfo;
    this.showInternet = this.showAmenitiesPolicyInfo;
    this.showParking = this.showAmenitiesPolicyInfo;
    this.showAirportTransport = this.showAmenitiesPolicyInfo;
    this.showLocalTransport = this.showAmenitiesPolicyInfo;
    this.showBidCancelPolicy = this.showAmenitiesPolicyInfo;
  }

  ClickAddGridToTemplate() {
    var ckeditor = (<any>window).CKEDITOR;
    var editor;
    //there should only be one editor
    //so grab the first propert after some basic checking
    //and break out of the for loop
    for (let prop in ckeditor.instances) {
      if (prop.match(/^editor/)) {
        editor = ckeditor.instances[prop];
      }
    }
    if (editor) {
      var output;
      if (this.auditType == 1) {
        output = '{{StandardAuditDataGrid ';
      }
      else if (this.auditType == 3) {
        output = '{{AvailabilityDataGrid ';
      }
      else {
        output = '{{ReverseAuditDataGrid  ';
      }

      output += this.AddBooleanToGridOutput('ShowGridLines', this.showGridLines);
      //for some reason, 'Show GDS Name' checkbox does not match up with 'ShowGDSName' attribute
      //instead, 'Show GDS Information' checkbox matches up with 'ShowGDSName' attribute
      //default foregrounds to black and backgrounds to white if for any reason they are undefined
      if (!this.headerTextForegroundColor) {
        this.headerTextForegroundColor = "#000000";
      }
      output += this.AddTextToGridOutput('HeaderTextForegroundColor',
        this.headerTextForegroundColor.toUpperCase());
      if (!this.headerTextBackgroundColor) {
        this.headerTextBackgroundColor = "#FFFFFF";
      }
      output += this.AddTextToGridOutput('HeaderTextBackgroundColor',
        this.headerTextBackgroundColor.toUpperCase());
      if (!this.gridTextForegroundColor) {
        this.gridTextForegroundColor = "#000000";
      }
      output += this.AddTextToGridOutput('TextForegroundColor',
        this.gridTextForegroundColor.toUpperCase());
      if (!this.gridTextBackgroundColor) {
        this.gridTextBackgroundColor = "#FFFFFF";
      }
      output += this.AddTextToGridOutput('TextBackgroundColor',
        this.gridTextBackgroundColor.toUpperCase());
      //'Show GDS Name' checkbox matches up with 'GDSName' attribute
      if (this.auditType == 2) {
        output += this.AddBooleanToGridOutput('ShowGDSInfo', this.showGDSInfo);
        output += this.AddBooleanToGridOutput('ShowGDSName', this.showGDSName);
        output += this.AddBooleanToGridOutput('ShowGDSChainCode', this.showChainCode);
        output += this.AddBooleanToGridOutput('ShowGDSPropCode', this.showPropCode);
        output += this.AddBooleanToGridOutput('ShowHotelInfo', this.showHotelInfo);
        output += this.AddBooleanToGridOutput('ShowHotelName', this.showHotelName);
        output += this.AddBooleanToGridOutput('ShowHotelAddr', this.showHotelAddress);
        output += this.AddBooleanToGridOutput('ShowHotelCity', this.showHotelCity);
        output += this.AddBooleanToGridOutput('ShowHotelState', this.showHotelState);
        output += this.AddBooleanToGridOutput('ShowHotelCountry', this.showHotelCountry);
        output += this.AddBooleanToGridOutput('ShowRAC', this.showRateAccessCode);
      } else {
        output += this.AddBooleanToGridOutput('ShowGDSName', this.showGDSInfo);
        output += this.AddBooleanToGridOutput('GDSName', this.showGDSName);
        output += this.AddBooleanToGridOutput('GDSChainCode', this.showChainCode);
        output += this.AddBooleanToGridOutput('GDSPropCode', this.showPropCode);
        output += this.AddBooleanToGridOutput('ShowPrice', this.showRateInfo);
        output += this.AddBooleanToGridOutput('GDSRateAccessCode', this.showRateAccessCode);
        output += this.AddBooleanToGridOutput('PriceCurrencyCode', this.showCurrencyCode);
        output += this.AddBooleanToGridOutput('PriceExpectedRate', this.showExpectedRate);
        output += this.AddBooleanToGridOutput('PriceProvidedRate', this.showProvidedRate);
        if (this.auditType == 1) {
          output += this.AddBooleanToGridOutput('WithCommission', this.showWithCommission);
          output += this.AddBooleanToGridOutput('PercentCommission', this.showPercentCommission);
          output += this.AddBooleanToGridOutput('ShowAmenitiesPolicy', this.showAmenitiesPolicyInfo);
          output += this.AddBooleanToGridOutput('Breakfast', this.showBreakfast);
          output += this.AddBooleanToGridOutput('Internet', this.showInternet);
          output += this.AddBooleanToGridOutput('Parking', this.showParking);
          output += this.AddBooleanToGridOutput('AirportTransport', this.showAirportTransport);
          output += this.AddBooleanToGridOutput('LocalTransport', this.showLocalTransport);
          output += this.AddBooleanToGridOutput('BidCancelPolicy', this.showBidCancelPolicy);
       }
      }
      while (output.match(/ $/g)) {
        output = output.replace(/ $/, '');
      }
      output += '}}';

      editor.insertHtml(output);
    }
  }

  AddBooleanToGridOutput(fieldName: string, bool: boolean) {
    let output = fieldName + '="';
    if (bool) {
      output += 'True';
    } else {
      output += 'False';
    }
    output += '" ';
    return output;
  }

  AddTextToGridOutput(fieldName: string, val: string) {
    let output = fieldName + '="';
    output += val;
    output += '" ';
    return output;
  }

}
